import { combineReducers } from "redux";
import authReducer from "./authReducer";
import cartReducer from "./cartReducer";
import dialogReducers from "./dialogReducers";
import generalReducer from "./generalReducer";
import coverageReducer from "./coverageReducer";
import addressReducer from "./addressReducer";
import locationReducer from "./locationReducer";
import sliderReducer from "./sliderReducer";
import navBarReducer from "./navBarReducer";

export default combineReducers({
  auth: authReducer,
  cart: cartReducer,
  dialog: dialogReducers,
  general: generalReducer,
  coverage: coverageReducer,
  address: addressReducer,
  location: locationReducer,
  searching: sliderReducer,
  navBar : navBarReducer
});
